import { render, staticRenderFns } from "./saveSearchcar.vue?vue&type=template&id=948f5b1e&scoped=true"
import script from "./saveSearchcar.vue?vue&type=script&lang=js"
export * from "./saveSearchcar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948f5b1e",
  null
  
)

export default component.exports